import * as types from '../actions/types';
const initialState = {
    liveSheetCache: undefined,
    liveSheetCacheTimestamp: undefined,
};
const liveSheetReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_LIVE_SHEET_SUCCESS:
            return {
                ...state,
                liveSheetCache: action.payload,
                liveSheetCacheTimestamp: Date.now(),
            };
        case types.POST_LIVE_SHEET_SYNC_SUCCESS: // fall through
        case types.POST_LIVE_SHEET_ENABLE_SUCCESS: // fall through
        case types.POST_LIVE_SHEET_DISABLE_SUCCESS:
            return {
                ...state,
                liveSheetCache: undefined,
                liveSheetCacheTimestamp: undefined,
            };
        default:
            return state;
    }
};
export default liveSheetReducer;
